package com.trevorwiebe.timesheet.admin.ownerOperator.presentation

import com.trevorwiebe.timesheet.core.domain.model.OwnerOperator

sealed class OwnerOperatorsEvent {
    data object OnAddOwnerOperatorClick : OwnerOperatorsEvent()
    data class OnEditOwnerOperatorClick(val ownerOperator: OwnerOperator) : OwnerOperatorsEvent()
    data object OnDismissDialog : OwnerOperatorsEvent()
    data class OnSaveOwnerOperator(
        val contactName: String,
        val companyName: String,
        val address: String,
        val phone: String,
        val email: String,
        val notes: String,
        val basePayPercent: Double?,
        val active: Boolean
    ) : OwnerOperatorsEvent()
    data object OnDeleteOwnerOperator : OwnerOperatorsEvent()
    data object OnRestoreOwnerOperator : OwnerOperatorsEvent()
    data class OnFilterToggled(val filter: OwnerOperatorFilter) : OwnerOperatorsEvent()
    data object OnErrorShown : OwnerOperatorsEvent()
}
